// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IInvestmentHoldingDetailsDto } from './IInvestmentHoldingDetailsDto';
import {
    IInvestmentHoldingDetailsDtoFromJSON,
    IInvestmentHoldingDetailsDtoFromJSONTyped,
    IInvestmentHoldingDetailsDtoToJSON,
    IInvestmentHoldingDetailsDtoToJSONTyped,
} from './IInvestmentHoldingDetailsDto';

/**
 * 
 * @export
 * @interface IInvestmentCashHoldingDetailsDto
 */
export interface IInvestmentCashHoldingDetailsDto extends IInvestmentHoldingDetailsDto {
    /**
     * 
     * @type {string}
     * @memberof IInvestmentCashHoldingDetailsDto
     */
    fund_name?: string;
}

/**
 * Check if a given object implements the IInvestmentCashHoldingDetailsDto interface.
 */
export function instanceOfIInvestmentCashHoldingDetailsDto(value: object): value is IInvestmentCashHoldingDetailsDto {
    return true;
}

export function IInvestmentCashHoldingDetailsDtoFromJSON(json: any): IInvestmentCashHoldingDetailsDto {
    return IInvestmentCashHoldingDetailsDtoFromJSONTyped(json, false);
}

export function IInvestmentCashHoldingDetailsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IInvestmentCashHoldingDetailsDto {
    if (json == null) {
        return json;
    }
    return {
        ...IInvestmentHoldingDetailsDtoFromJSONTyped(json, true),
        'fund_name': json['fund_name'] == null ? undefined : json['fund_name'],
    };
}

export function IInvestmentCashHoldingDetailsDtoToJSON(json: any): IInvestmentCashHoldingDetailsDto {
    return IInvestmentCashHoldingDetailsDtoToJSONTyped(json, false);
}

export function IInvestmentCashHoldingDetailsDtoToJSONTyped(value?: IInvestmentCashHoldingDetailsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        ...IInvestmentHoldingDetailsDtoToJSONTyped(value, true),
        'fund_name': value['fund_name'],
    };
}

